import React, { FC, MouseEvent } from "react";
import { useSetRecoilState } from "recoil";
import { OuNotice, useIsHubSpotCrm } from "../CrmUi";
import { hubspotPageAtom } from "../../state/atoms";
import { BILLING_DEEP_LINK, PlanFeature, planRequiredMessage } from "../../common/plans";

/**
 * Where the plan is changed: HubSpot orgs get their Billing page in the side
 * navigation; Outreach orgs scroll Settings to its Billing section, or load
 * the dashboard opened on it when Settings is not on screen.
 */
export const useGoToBilling = () => {
  const isHubSpot = useIsHubSpotCrm();
  const setHubspotPage = useSetRecoilState(hubspotPageAtom);
  return (event?: MouseEvent) => {
    event?.preventDefault();
    if (isHubSpot) {
      setHubspotPage("billing");
      return;
    }
    const section = document.getElementById("section-billing");
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.assign(BILLING_DEEP_LINK);
  };
};

interface Props {
  feature: PlanFeature;
  /** What the feature does, for the sentence: "to use LinkedIn automation". */
  what?: string;
}

/**
 * Plan gating: shown where a feature appears for an organization whose plan
 * leaves it out. In the look of the org's CRM (OuNotice). Organizations from
 * before plan gating never see it: the backend never reports them locked.
 */
const PlanUpgradePrompt: FC<Props> = ({ feature, what }) => {
  const goToBilling = useGoToBilling();
  return (
    <OuNotice tone="warning">
      {planRequiredMessage(feature)}
      {what ? ` to use ${what}` : ""}.{" "}
      <a href={BILLING_DEEP_LINK} onClick={goToBilling} style={{ color: "inherit", fontWeight: 600, textDecoration: "underline" }}>
        See plans
      </a>
    </OuNotice>
  );
};

export default PlanUpgradePrompt;
